export default "__VITE_ASSET__C2i58ghj__"